import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChipsComponent} from './chips.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatChipsModule} from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import {CommonDirectivesModule} from '../../pipes/directives.module';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  declarations: [ChipsComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatChipsModule, MatFormFieldModule, CommonDirectivesModule, MatIconModule],
  exports: [ChipsComponent]
})
export class ChipsModule {}
